import { render, staticRenderFns } from "./RelatoryCity.vue?vue&type=template&id=483be7ad&scoped=true"
import script from "./RelatoryCity.vue?vue&type=script&lang=js"
export * from "./RelatoryCity.vue?vue&type=script&lang=js"
import style0 from "./RelatoryCity.vue?vue&type=style&index=0&id=483be7ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483be7ad",
  null
  
)

export default component.exports